/**
 * O checklist de implantação de uma empresa.
 *
 * Mora na rota da empresa (`/companies/:id/implantacao`) porque é dela que fala, e é a
 * permissão dela (`company.read`) que o servidor cobra.
 */

import apiClient from './apiClient';
import { ChecklistDaImplantacao } from '../types/implantacao';

export const implantacaoService = {
  async checklist(companyId: number | string): Promise<ChecklistDaImplantacao> {
    const resposta = await apiClient.get<ChecklistDaImplantacao>(
      `/companies/${String(companyId)}/implantacao`
    );

    if (!resposta.data) throw new Error('Não foi possível montar o checklist desta empresa.');

    return resposta.data;
  },
};

export default implantacaoService;
